import { useState, useEffect } from "react"
import Image from "next/legacy/image"
//import Dinero from "dinero.js"

import { useCartContext } from "@/components/woocommerce/cartStore"
import { currency } from "@/lib/helpers/woocommerce"
import { decodeHTMLEntities } from "@/lib/helpers/utils"

import QuantityInput from "@/components/woocommerce/QuantityInput"
import ProductPrice from "@/components/woocommerce/ProductPrice"
import { itemInArrayHasOwn } from "@/lib/helpers/utils"

const MiniCartItem = ({ item, disableQuantity, isDisabled }) => {
  const { isLoading, updateCartItem, removeCartItem } = useCartContext()
  const { key, name, images, prices, quantity, variation, quantity_limit } =
    item
  const [firstImage] = images
  const { src: imageSrc } = firstImage ?? {}

  const currentVariations = variation.filter((variant) => {
    return variant.attribute !== "Priskategori"
  })

  const [currentQty, setCurrentQty] = useState(quantity)

  const linePrice = prices.price * quantity

  useEffect(() => {
    const timer = setTimeout(() => {
      if (currentQty === "") {
        return
      }
      if (currentQty === 0) {
        removeCartItem(key)
        return
      }

      if (currentQty === quantity) {
        return
      }

      if (currentQty !== quantity) {
        updateCartItem(key, currentQty)
        return
      }
    }, 400)

    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentQty])

  if (itemInArrayHasOwn(item.item_data, "is_shipping")) {
    return null
  }

  return (
    <li key={key} className="mb-5 sm:flex">
      <div className="flex pb-3 sm:pb-0 sm:w-full">
        {imageSrc && (
          <figure className="flex-shrink-0 w-10 h-10 mr-4">
            <Image
              src={imageSrc}
              alt={decodeHTMLEntities(name)}
              layout="intrinsic"
              width="40"
              height="40"
              objectFit="cover"
              className="object-cover w-full h-full"
            />
          </figure>
        )}
        <div className="pr-4 caption">
          <p className="mb-0 leading-tight">
            {decodeHTMLEntities(name)}
            {currentVariations.length
              ? ` (${currentVariations
                  .map((variation) => variation.value)
                  .join(", ")})`
              : null}
          </p>
          <ProductPrice
            className="mb-0 text-base font-medium leading-none sm:text-lg lg:text-xl"
            currency={currency}
            price={linePrice}
          />
        </div>
      </div>
      {!disableQuantity && (
        <QuantityInput
          minimum={0}
          maximum={quantity_limit}
          defaultQty={quantity}
          setCurrentQty={setCurrentQty}
          className="flex-nowrap sm:h-10 sm:flex-shrink-0"
          isDisabled={isLoading || isDisabled}
        />
      )}
    </li>
  )
}

export default MiniCartItem
